import React from 'react';
import { Row, Col, Label, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import { AvGroup, AvField } from 'availity-reactstrap-validation';
import Select from 'react-select';
import FormPegawaiBaru from './FormPegawaiBaru';

const FormPegawai = ({ formState, setFormState, masterData, isSubmitted, setAlertState }) => {
    let asalInstansi = '-';
    let jenisPegawai = '-';

    if (formState.selectedEmployee) {
        const catFull = formState.selectedEmployee.employee_categories_name_full || '';
        const parts = catFull.split('»').map(s => s.trim());
        if (parts.length > 1) {
            asalInstansi = parts[0] || '-';
            jenisPegawai = parts[1] || '-';
        } else {
            asalInstansi = formState.selectedEmployee.ministry_name || '-';
            jenisPegawai = formState.selectedEmployee.employee_categories_name || '-';
        }
    }

    return (
        <React.Fragment>

            {formState.type === 3 && (
                <Row>
                    <Col md={12}>
                        <AvGroup className="mb-2">
                            <Label>Alasan Pemberhentian <span className="text-danger">*</span></Label>
                            <Select
                                options={masterData.stopCauses}
                                value={masterData.stopCauses.find(opt => opt.value === formState.stop_cause)}
                                onChange={(e) => setFormState({ ...formState, stop_cause: e.value })}
                                placeholder="Pilih Alasan Pemberhentian"
                                className={(isSubmitted && !formState.stop_cause) ? "border border-danger rounded" : ""}
                            />
                            {isSubmitted && !formState.stop_cause && <div className="invalid-feedback d-block">Wajib diisi</div>}
                            <AvField name="stop_cause" type="text" value={formState.stop_cause || ''} required errorMessage="Alasan Pemberhentian wajib dipilih"  validate={{ required: { value: true, errorMessage: 'Wajib diisi' } }} className="d-none" />
                        </AvGroup>
                    </Col>
                </Row>
            )}

            {formState.type === 1 && (
                <React.Fragment>
                    <Row>
                        <Col md={12}>
                            <AvGroup className="mb-2">
                                <Label>Data Pegawai <span className="text-danger">*</span></Label>
                                <Select
                                    options={[{value: 'lama', label: 'Pegawai Lama'}, {value: 'baru', label: 'Pegawai Baru'}]}
                                    value={[{value: 'lama', label: 'Pegawai Lama'}, {value: 'baru', label: 'Pegawai Baru'}].find(opt => opt.value === formState.employee_internal_type)}
                                    onChange={(e) => setFormState({ ...formState, employee_internal_type: e.value, employee_origin: null, employee_uuid: null, selectedEmployee: null, new_employee_nip: '', new_employee_name: '' })}
                                    placeholder="Pilih Data Pegawai"
                                    className={(isSubmitted && !formState.employee_internal_type) ? "border border-danger rounded" : ""}
                                />
                                {isSubmitted && !formState.employee_internal_type && <div className="invalid-feedback d-block">Wajib diisi</div>}
                                <AvField name="employee_internal_type" type="text" value={formState.employee_internal_type || ''} required errorMessage="Data Pegawai wajib dipilih" validate={{ required: { value: true, errorMessage: 'Wajib diisi' } }} className="d-none" />
                            </AvGroup>
                        </Col>
                    </Row>

                    {formState.employee_internal_type === 'baru' && (
                        <div className="p-4 mt-3 bg-light border mb-3" style={{ borderRadius: '8px' }}>
                            <h6 className="text-primary font-weight-bold mb-3 border-bottom pb-2">Form Pegawai Baru</h6>
                            <FormPegawaiBaru autoFillSignal={formState.autoFillSignal} defaultValues={formState} />
                        </div>
                    )}
                </React.Fragment>
            )}

            {((formState.type === 1 && formState.employee_internal_type === 'lama') || formState.type === 2 || formState.type === 3) && (
                <Row>
                    <Col md={12}>
                        <AvGroup className="mb-2">
                            <Label>Pegawai <span className="text-danger">*</span></Label>
                            <Select
                                options={masterData.employees}
                                value={masterData.employees.find(opt => opt.value === formState.employee_uuid)}
                                onChange={(e) => {
                                    if (masterData.existingEmployeeUuids && masterData.existingEmployeeUuids.includes(e.value)) {
                                        if (setAlertState) {
                                            setAlertState(prev => ({ 
                                                ...prev, 
                                                failed: true, 
                                                failedTitle: 'Gagal!', 
                                                failedInfo: 'Pegawai tersebut sudah dimutasi pada periode ini.' 
                                            }));
                                        }
                                        return;
                                    }
                                    const selectedPos = masterData.positions ? masterData.positions.find(p => p.value === e.employee_current_position_uuid) : null;
                                    const posTypeUuid = selectedPos ? selectedPos.position_type_uuid : null;

                                    setFormState({ 
                                        ...formState, 
                                        employee_uuid: e.value,
                                        selectedEmployee: e,
                                        employee_transfer_detail_work_unit_uuid: e.employee_current_work_unit_uuid,
                                        employee_transfer_detail_position_uuid: e.employee_current_position_uuid,
                                        employee_transfer_detail_position_type_uuid: posTypeUuid
                                    });
                                }}
                                placeholder="Pilih Pegawai"
                                className={(isSubmitted && !formState.employee_uuid) ? "border border-danger rounded" : ""}
                            />
                            {isSubmitted && !formState.employee_uuid && <div className="invalid-feedback d-block">Wajib diisi</div>}
                            <AvField name="employee_uuid" type="text" value={formState.employee_uuid || ''} required={((formState.type === 1 && formState.employee_internal_type === 'lama') || formState.type === 2 || formState.type === 3)} errorMessage="Pegawai wajib dipilih"  validate={{ required: { value: ((formState.type === 1 && formState.employee_internal_type === 'lama') || formState.type === 2 || formState.type === 3), errorMessage: 'Wajib diisi' } }} className="d-none" />
                        </AvGroup>
                    </Col>
                </Row>
            )}

            {formState.selectedEmployee && (
                <div className="p-4 mt-3 bg-light border" style={{ borderRadius: '8px' }}>
                    <Row>
                        <Col md={6}>
                            <p className="mb-1"><small className="text-muted">Nama Pegawai</small><br/><strong>{formState.selectedEmployee.employee_full_name}</strong></p>
                            <p className="mb-1"><small className="text-muted">NIP</small><br/><strong>{formState.selectedEmployee.employee_nip}</strong></p>
                            <p className="mb-1"><small className="text-muted">Jenis Pegawai</small><br/><strong>{jenisPegawai}</strong></p>
                            <p className="mb-0"><small className="text-muted">Asal Instansi</small><br/><strong>{asalInstansi}</strong></p>
                        </Col>
                        <Col md={6}>
                            <p className="mb-1"><small className="text-muted">Jenis Jabatan</small><br/><strong>{formState.selectedEmployee.position_type_name || '-'}</strong></p>
                            <p className="mb-1"><small className="text-muted">Jabatan Lama</small><br/><strong>{formState.selectedEmployee.position_name || formState.selectedEmployee.employee_current_position_name}</strong></p>
                            <p className="mb-0"><small className="text-muted">Unit Kerja Lama</small><br/><strong>{formState.selectedEmployee.work_unit_name || formState.selectedEmployee.employee_current_work_unit_name_short}</strong></p>
                        </Col>
                    </Row>
                </div>
            )}
        </React.Fragment>
    );
};

export default FormPegawai;
